var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticStyle: {
            position: "absolute",
            top: "0",
            right: "0",
            left: "0",
            bottom: "0",
            "background-color": "rgba(0, 0, 0, 0.2)",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                margin: "auto",
                top: "0",
                right: "0",
                bottom: "0",
                left: "0",
                "padding-bottom": "54px",
                width: "320px",
                "border-radius": "2px",
                "background-color": "#ffffff",
                "box-shadow": "0 0 5px rgba(0, 0, 0, 0.2)",
              },
              style: {
                "padding-top": _vm.config.title ? "30px" : 0,
                height: _vm.config.title ? "128px" : "128px",
              },
            },
            [
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.config.title,
                      expression: "config.title",
                    },
                  ],
                  staticStyle: {
                    position: "absolute",
                    top: "10px",
                    left: "0",
                    width: "100%",
                    padding: "0px 16px",
                    "font-size": "16px",
                    "line-height": "20px",
                  },
                },
                [_vm._v(_vm._s(_vm.config.title))]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "100%",
                    padding: "15px 16px 10px 16px",
                    overflow: "auto",
                  },
                },
                [_c("p", [_vm._v(_vm._s(_vm.message))])]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }